import { lazy } from "react";
import Icon from "../../components/Icon";

const SpeedTest = lazy(() => import("./SpeedTest"));
const SpeedTestHistory = lazy(() => import("./SpeedTestHistory"));

let SpeedTestRoutes = [
  {
    path: "/speed-test",
    exact: true,
    title: "تست سرعت",
    sidebar: true,
    iconTag: <Icon name={"speed"} className={"drawerIcons large"} />,
    component: SpeedTest,
    roles: ["LIMITED"],
  },
  {
    path: "/speed-test/history",
    exact: false,
    title: "سوابق تست سرعت",
    sidebar: true,
    iconTag: <Icon name={"open-folder-outline"} className={"drawerIcons large"} />,
    component: SpeedTestHistory,
    roles: ["LIMITED"],
  },
];

export default SpeedTestRoutes;
